export const environment = {
  production: true,
  tt_s3_url_prefix: 'https://assets.tt.com',
  tt_com_processing_endpoint: 'processing.tt.com',
};
